export default __webpack_public_path__ + "static/media/gulp.bf812025.svg";